import ReactDOM from 'react-dom';
import App from './App';
import { initApp, startMockServiceWorker } from './init';

initApp();

startMockServiceWorker()
  .catch(console.error)
  .then(() => {
    ReactDOM.render(<App />, document.getElementById('root'));
  });
